import React from "react";
import { Modal, ModalBody, ModalHeader, Row, Col } from "reactstrap";
import { urlBaseAgendamento, urlDomain } from "../../../utils/services/config";

export default function ModalLinksEmbeded(props) {
  const { isOpen, toggle, eventId, targetOrigin } = props;

  async function clipBoard(url) {
    await navigator.clipboard.writeText(url);
    alert("O link foi copiado para a área de transferência");
  }
  //

  return (
    <Modal isOpen={isOpen} autoFocus={true} centered={true}>
      <ModalHeader toggle={toggle}>Link Externo</ModalHeader>
      <ModalBody>
        <Row style={{ marginBottom: 10 }}>
          <Col lg={12}>
            <label className="form-label">
              URL Dashboard
              <i
                className="mdi mdi-content-copy"
                style={{
                  color: "grey",
                  fontSize: 17,
                  marginLeft: 10,
                  cursor: "pointer",
                }}
                title="Copiar"
                onClick={() => clipBoard(`${targetOrigin}/?idEvent=${eventId}`)}
              />
            </label>
            <input
              className="form-control"
              disabled
              value={`${targetOrigin}/?idEvent=${eventId}`}
            />
          </Col>
        </Row>
      </ModalBody>
    </Modal>
  );
}
